import { combineReducers } from "redux";

import error from "./error";
import user from "./user";
import control from "./control";

export default combineReducers({
  error,
  user,
  control,
});
